$(document).ready(function() {
  var pickupLabel = "Ritiro in Farmacia? (Pessione di Chieri,TO)"; // the text of the label
  var buttonArea = $('.cart-checkbox'); // where to insert the option
  var pickupVariantId = 26676973321; // the variant ID of the local pickup product

  Shopify.getCart(function(cart) {
    var inCart = false;
    $.each(cart.items, function(index, item) {
      if (item.variant_id == pickupVariantId) {
        inCart = true;
        return false;
      }
    });
    buttonArea.append('<div style="text-align: left;"><label for="local-pickup"><input id="local-pickup" type="checkbox"' + (inCart ? ' checked' : '') + ' /> ' + pickupLabel+ '</label><div style="color:#3ba65b;font-size:10px;margin-top: -10px;margin-left: 20px;margin-bottom: 10px;">Valido per indirizzi in provincia di Torino</div></div>');
  });

  buttonArea.on('change', '#local-pickup', function() {
    if ($(this).is(':checked')) {
      Shopify.addItem(pickupVariantId, 1, function(item) {
        location.reload();
      });
    } else {
      Shopify.changeItem(pickupVariantId, 0, function(cart) {
        location.reload();
      });
    }
  });

});